module.exports = __webpack_public_path__ + "static/media/flag-blue.5b90cf36.svg";